import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home } from 'lucide-react';

const PRODUCT_LINKS = [
  { to: '/p2p', label: 'P2P' },
  { to: '/predictions', label: 'Tips' },
];

const ShowcaseNavigation = ({ title, icon: Icon }) => {
  const location = useLocation();

  return (
    <motion.nav
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-900 via-black to-blue-900 shadow-lg"
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 text-white hover:text-blue-400 transition-colors duration-300"
          >
            <Home className="w-5 h-5" />
            <span className="text-sm font-medium">Back to Home</span>
          </Link>

          <div className="flex items-center gap-2">
            {Icon && <Icon className="w-6 h-6 text-blue-400" />}
            <h1 className="text-xl md:text-2xl font-bold text-white">
              {title}
            </h1>
          </div>

          <div className="flex items-center gap-1">
            {PRODUCT_LINKS.map((link) => {
              const active = location.pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
                    active
                      ? 'bg-white/15 text-white'
                      : 'text-white/60 hover:text-white'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default ShowcaseNavigation;
